var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-login",style:({height: _vm.screenHeight + 'px'})},[_c('div',{staticClass:"content-left"},[_c('login-background-image-layout')],1),_c('div',{staticClass:"content-right"},[_c('login-form-layout',{attrs:{"texts":_vm.texts}}),_c('select-language-component')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }